import { Space, Switch, Typography } from "antd";
import PropTypes from "prop-types";

import { useCustomToolStore } from "../../store/custom-tool-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";
import { useAlertStore } from "../../store/alert-store";

function SinglePassToggleSwitch({ handleUpdateTool }) {
  const {
    updateCustomTool,
    isMultiPassExtractLoading,
    singlePassExtractMode,
    isSinglePassExtractLoading,
    isPublicSource,
  } = useCustomToolStore();
  const handleException = useExceptionHandler();
  const { setAlertDetails } = useAlertStore();

  const handleSinglePassExtractChange = (value) => {
    updateCustomTool({
      singlePassExtractMode: value,
    });

    handleUpdateTool({
      single_pass_extraction_mode: value,
    })
      .then((res) => {
        updateCustomTool({
          details: res?.data,
        });
      })
      .catch((err) => {
        setAlertDetails(
          handleException(
            err,
            "Failed to switch the single pass extraction mode"
          )
        );
        // Revert the mode if the API fails
        updateCustomTool({
          singlePassExtractMode: !value,
        });
      });
  };

  return (
    <Space>
      <Typography.Text className="font-size-12">
        SinglePass Extraction
      </Typography.Text>
      <Switch
        size="small"
        checked={singlePassExtractMode}
        disabled={
          isMultiPassExtractLoading ||
          isSinglePassExtractLoading ||
          isPublicSource
        }
        onChange={(value) => handleSinglePassExtractChange(value)}
      />
    </Space>
  );
}

SinglePassToggleSwitch.propTypes = {
  handleUpdateTool: PropTypes.func.isRequired,
};

export { SinglePassToggleSwitch };
